<template>
  <vx-tooltip :text="$t('reset_password')">
    <vs-button color="primary" type="filled" icon-pack="feather" icon="icon-lock" size="small" @click.prevent="resetPassword"></vs-button>
  </vx-tooltip>
</template>

<script>
import Users from '@/models/User'

export default {
  name: 'ResetPasswordButton',
  props: {
    userId: {
      required: true,
      type: Number
    }
  },
  methods: {
    async resetPassword () {
      const confirm = await this.$swalHelper.warning({
        title: this.$t('are_you_sure_you_want_to_reset_password'),
        confirmButton: this.$t('execution'),
        cancelButton: this.$t('cancel')
      })

      if (confirm.value) {
        try {
          const response = await Users.resetPassword({ id: this.userId })

          this.$swalHelper.success({
            title: this.$t('action_success'),
            text: this.$t(response.data),
            confirmButton: this.$t('confirm')
          })
        } catch (e) {
          this.$swalHelper.displayCatchError({
            title: 'Error!',
            errorObject: e,
            confirmButton: this.$t('confirm')
          })
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
